import { render, staticRenderFns } from "./BuyerProductCard.vue?vue&type=template&id=9a133c02&scoped=true"
import script from "./BuyerProductCard.vue?vue&type=script&lang=js"
export * from "./BuyerProductCard.vue?vue&type=script&lang=js"
import style0 from "./BuyerProductCard.vue?vue&type=style&index=0&id=9a133c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a133c02",
  null
  
)

export default component.exports